import { Observable, of } from 'rxjs';
import { Injectable } from '@angular/core';
import { PasswordApi } from '../api/password.api';
import { delay } from 'rxjs/operators';

@Injectable()
export class PasswordMockService {
  readonly mockDelay = 1500;

  constructor() {}

  setPassword(request: PasswordApi.SetPassword.Request): Observable<void> {
    return of(undefined);
  }

  changePassword(
    request: PasswordApi.ChangePassword.Request
  ): Observable<void> {
    return of(undefined);
  }

  validateDateOfBirth(
    request: PasswordApi.UserVerify.Request
  ): Observable<PasswordApi.UserVerify.Response> {
    return of({
      noOfRetry: 1,
      oneTimeCode: 'one-time-code',
      transactionId: 'transaction-id',
      validTimeInMinutes: 12
    }).pipe(delay(this.mockDelay));
  }
}
